/**
 * Removes a specified query parameter from a given URL string.
 *
 * @param {string} urlString - The URL string from which the parameter should be removed.
 * @param {string} removeParam - The name of the query parameter to remove.
 * @returns {string} - The new URL string with the specified parameter removed.
 */
export function getUrlWithRemovedParam(urlString, removeParam) {
	const urlObj = new URL(urlString);
	const params = new URLSearchParams(urlObj.search);
	while (params.has(removeParam)) {
		params.delete(removeParam);
	}
	const newParamList = params.toString();
	const divider = newParamList !== '' ? '?' : '';
	return urlObj.origin + urlObj.pathname + divider + newParamList;
}

export function awaitTimeout(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export function hasStorageAccess() {
	try {
		localStorage.setItem('featureTest', 'true');
		localStorage.removeItem('featureTest');
		return true;
	} catch {
		return false;
	}
}
